import './fixed_header.less';

import React, {Proptypes} from 'react';
import {Link} from 'react-router';

export default class FixedHeader extends React.Component {
  constructor(props) {
    super(props);
  }

  render(){
    return(
          <div className = "fixed-header">
            <div className = "logo-wrp">
              <Link to="/"><img className="logo-img" src="../public/images/landing/awb_logo.png" />
              </Link>
            </div>
            <div className = "menu-options-wrp">
              <div className = "link-wrap">
                {/* <Link>Learn More</Link> */}
              </div>
              <div className = "link-wrap">
                <Link to="/signup">Sign Up</Link>
              </div>
              <div className = "link-wrap">
                <Link to="/login">Log In</Link>
              </div>
              <div className="option-img-wrap link-wrap">
                <a className="link" target="_blank" href="http://play.google.com/store/apps/details?id=com.awb.android">
                  <img className = "playstore-img" src="../public/images/landing/playstore.png"/>
                </a>
              </div>
              <div className="option-img-wrap link-wrap">
                <a className="link" target="_blank" href="https://itunes.apple.com/us/app/airwaybill/id1198529029?ls=1&mt=8">
                  <img className = "appstore-img" src="../public/images/landing/appstore.png"/>
                </a>
                </div>
            </div>
        </div>
    )
  }
}



// WEBPACK FOOTER //
// app/header/fixed_header.jsx